import { MenuItem, TextField } from "@mui/material";
import { useGetAllUsersQuery } from "app/api/users";
import { UserRole } from "features/auth/types/user";
import { useMemo } from "react";

type SellerSelectProps = { value: string | null; onChange: (value: string | null) => void };

const SellerSelect: React.FC<SellerSelectProps> = (props) => {
  const { value, onChange } = props;

  const { data: sellers } = useGetAllUsersQuery({ roles: [UserRole.SALES] });

  const validSellers = useMemo(
    () =>
      sellers?.filter(
        (seller) => seller.userName && seller.pyramidSignature && seller.state === "ACTIVE"
      ),
    [sellers]
  );

  return (
    <TextField
      select
      label="Säljare"
      variant="filled"
      value={value || ""}
      onChange={(e) => onChange(e.target.value || null)}
    >
      <MenuItem value="" sx={{ color: "text.secondary" }}>
        Alla
      </MenuItem>
      {validSellers?.map((seller) => (
        <MenuItem key={seller.id} value={seller.pyramidSignature!}>
          {seller.userName}
        </MenuItem>
      ))}
    </TextField>
  );
};

export default SellerSelect;
